import useTranslate from '../../useTranslate';
import { usePbDispatch, usePbSelector } from '../../../store/pbStoreHooks';
import React, { useEffect, useState } from 'react';
import LargeCard from '../../main/large-card';
import Spinner from '../../util/spinner';
import {
    ContractDetailsUpdateDto,
    ResetUserDetailsUpdates,
    UpdateContractDetails,
} from '../../../store/userDetailsSlice';
import EditLargeCardFormik from '../../main/edit-large-card-formik';
import ProfileContractDetailsForm, {
    validateContractDetails,
} from './profile-contract-details-form';
import { RequestStatus } from '../../../store/network/managedRequest';
import { PbRequest } from '../../../store/pbRequest';

interface Props {
    footnote?: string;
    disabled?: boolean;
    internalManager?: boolean;
}

function ProfileContractDetailsCard(props: Readonly<Props>) {
    const strings = useTranslate('EditProfile');
    const [newInit, setNewInit] = useState(false);

    const dispatch = usePbDispatch();
    const fetchContractDetails = usePbSelector(
        (state) => state.pbRequest[PbRequest.FETCH_CONTRACT_DETAILS]
    );
    const updateContractDetails = usePbSelector(
        (state) => state.pbRequest[PbRequest.UPDATE_CONTRACT_DETAILS]
    );
    const contractDetails = usePbSelector(
        (state) => state.userDetails.contractDetails
    );

    useEffect(() => {
        if (!newInit && fetchContractDetails.status === 'PENDING') {
            setNewInit(true);
        } else if (newInit && fetchContractDetails.status === 'SUCCESS') {
            setNewInit(false);
        }
    }, [fetchContractDetails.status, newInit]);

    useEffect(() => {
        return () => {
            dispatch(ResetUserDetailsUpdates());
        };
    }, []);

    const dataReady =
        fetchContractDetails.status === 'SUCCESS' && !!contractDetails;

    if (fetchContractDetails.status === 'FAILURE') {
        return (
            <LargeCard title={strings.contractDetails} type={'card-edit'}>
                -
            </LargeCard>
        );
    }
    if (!dataReady) {
        return (
            <LargeCard title={strings.contractDetails} type={'card-edit'}>
                <Spinner />
            </LargeCard>
        );
    }

    const initialValues: ContractDetailsUpdateDto = {
        ...contractDetails,
        confirm: false,
    };

    return (
        <EditLargeCardFormik
            title={strings.contractDetails}
            handleSubmit={handleSubmit}
            initialValues={initialValues}
            validate={validateContractDetails}
            enableReinitialize={newInit}
            error={updateContractDetails.status === RequestStatus.FAILURE}
            footnote={props.footnote}
            disabled={props.disabled}
        >
            {(formProps) => (
                <ProfileContractDetailsForm
                    disabled={!formProps.active}
                    isAdmin={props.internalManager}
                    mayChangeCountry={false}
                    submitRequest={updateContractDetails}
                />
            )}
        </EditLargeCardFormik>
    );

    function handleSubmit(values: ContractDetailsUpdateDto) {
        dispatch(UpdateContractDetails(values));
    }
}

export default ProfileContractDetailsCard;
